import React from 'react';
import PropTypes from 'prop-types';

import { safeVideoHref, resolveVideoHost } from '../utils';
import styles from '../../collegeProspectTab.scss';

const noop = () => {};

const VideoLinkList = ({ videos, onVideoPlayed, 'data-testid': dataTestId }) => (
    <div
        className={styles.recruitingVideosList}
        data-testid={dataTestId && `${dataTestId}.list`}
    >
        {videos.map((video, index) => (
            <div
                key={video.id}
                className={styles.recruitingVideoRow}
                data-testid={dataTestId && `${dataTestId}.item-${video.id}`}
            >
                <a
                    href={safeVideoHref(video.url)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.recruitingVideoTitleLink}
                    data-testid={dataTestId && `${dataTestId}.item-${video.id}.link`}
                    onClick={() => onVideoPlayed({
                        videoId: video.id,
                        host: resolveVideoHost(video.url),
                        videoIndex: index,
                    })}
                >
                    <svg
                        className={styles.recruitingVideoIcon}
                        viewBox="0 0 20 20"
                        aria-hidden="true"
                        focusable="false"
                    >
                        <circle cx="10" cy="10" r="8.5" fill="none" stroke="currentColor" strokeWidth="1.5" />
                        <path d="M8.5 6.75 L14 10 L8.5 13.25 Z" fill="currentColor" />
                    </svg>
                    <span
                        className={styles.recruitingVideoTitle}
                        data-testid={dataTestId && `${dataTestId}.item-${video.id}.title`}
                    >
                        {video.title}
                    </span>
                </a>
                {video.description && (
                    <div
                        className={styles.recruitingVideoDescription}
                        data-testid={dataTestId && `${dataTestId}.item-${video.id}.description`}
                    >
                        {video.description}
                    </div>
                )}
            </div>
        ))}
    </div>
);

VideoLinkList.propTypes = {
    videos: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        title: PropTypes.string,
        description: PropTypes.string,
        url: PropTypes.string,
    })).isRequired,
    onVideoPlayed: PropTypes.func,
    'data-testid': PropTypes.string,
};

VideoLinkList.defaultProps = {
    onVideoPlayed: noop,
    'data-testid': undefined,
};

export default VideoLinkList;
